
import React from "react";
import "../css/components/Checkbox.css"; 

const Checkbox = ({ id, label, checked, onChange, disabled = false }) => {
  return (
    <div className="checkbox-container">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="checkbox"
      />
      {label && (
        <label htmlFor={id} className="label">
          {label}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
